import { FanSpeed1Icon } from './FanSpeed1Icon';

/**
 * author: Michael Irigoyen
 * id F01D5822-D36A-4A41-9544-3B1E8702582F
 * name fan-speed-1
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fan-speed-1.svg
 * tags
 * - Home Automation 
 */
export const FanSpeedLowIcon = FanSpeed1Icon;
export default FanSpeedLowIcon